module.exports = __webpack_public_path__ + "img/graph-icon.a8ebfb95.svg";